import { appCode } from '../common/consts';

// lazy load the route, telling webpack what name to assign the chunk
const ChannelSetup = () => import(/* webpackChunkName: "Channel-Setup" */ '@/views/channelSetup/Index');

// SMS ROUTES
const SMSLandingPage = () => import(/* webpackChunkName: "SMS-LandingPage" */ '@/views/sms/LandingPage');
const SMSOnboardingPage = () => import(/* webpackChunkName: "SMS Onboarding" */ '@/views/sms/onboarding/Index');
const SMSCreateConnector = () =>
  import(/* webpackChunkName: "SMS-Create-Connector-Page" */ '@/views/sms/onboarding/CreateConnector');
const SMSConfigureConnector = () =>
  import(/* webpackChunkName: "SMS-Configure-Connector-Page" */ '@/views/sms/onboarding/ConfigureConnector');
const SMSSelectNumber = () =>
  import(/* webpackChunkName: "SMS-Select-Number-Page" */ '@/views/sms/onboarding/SelectNumber');
const SMSSkillRouting = () =>
  import(/* webpackChunkName: "SMS-Skill-Routing-Page" */ '@/views/sms/onboarding/SkillRouting');
const SMSTestConnector = () =>
  import(/* webpackChunkName: "SMS-Test-Connector-Page" */ '@/views/sms/onboarding/TestConnector');

// AMB ROUTES
const AMBLandingPage = () => import(/* webpackChunkName: "AMB-LandingPage" */ '@/views/amb/LandingPage');
const AMBOnboardingPage = () => import(/* webpackChunkName: "AMB-Onboarding" */ '@/views/amb/onboarding/Index');
const AppleBusinessPage = () =>
  import(/* webpackChunkName: "AMB-Apple-Business-Page" */ '@/views/amb/onboarding/AppleBusiness');
const ConnectorInfoPage = () =>
  import(/* webpackChunkName: "AMB-Connector-Info-Page" */ '@/views/amb/onboarding/ConnectorInfo');
const ConfigureConnectorPage = () =>
  import(/* webpackChunkName: "AMB-Configure-Connector-Page" */ '@/views/amb/onboarding/ConfigureConnector');
const SkillRoutingPage = () =>
  import(/* webpackChunkName: "AMB-Skill-Routing-Page" */ '@/views/amb/onboarding/SkillRouting');
const TestConnectorPage = () =>
  import(/* webpackChunkName: "AMB-Test-Connector-Page" */ '@/views/amb/onboarding/TestConnector');
const EntryPointsPage = () =>
  import(/* webpackChunkName: "AMB-Entry-Points-Page" */ '@/views/amb/onboarding/EntryPoints');

// WHATSAPP ROUTES
const WhatsAppHomePage = () => import(/* webpackChunkName: "Whatsapp-HomePage" */ '@/views/whatsapp/Index');
const WhatsAppOnboardingPage = () =>
  import(/* webpackChunkName: "Whatsapp-Onboarding" */ '@/views/whatsapp/onboarding/Index');
const WhatsAppLoginPage = () =>
  import(/* webpackChunkName: "Whatsapp-Create-Connector" */ '@/views/whatsapp/onboarding/Login');
const WhatsAppSelectLocale = () =>
  import(/* webpackChunkName: "Whatsapp-Select-Locale" */ '@/views/whatsapp/onboarding/SelectLocale');
const WhatsAppEditProfile = () =>
  import(/* webpackChunkName: "Whatsapp-Edit-Profile" */ '@/views/whatsapp/onboarding/EditProfile');
const WhatsAppConfigureConnector = () =>
  import(/* webpackChunkName: "Whatsapp-Configure-Connector" */ '@/views/whatsapp/onboarding/ConfigureConnector');
const WhatsAppConfigureCommerce = () =>
  import(/* webpackChunkName: "Whatsapp-Configure-Commerce" */ '@/views/whatsapp/onboarding/ConfigureCommerce');
const WhatsAppSkillRouting = () =>
  import(/* webpackChunkName: "Whatsapp-Skill-Routing" */ '@/views/whatsapp/onboarding/SkillRouting');
const WhatsAppTestConnector = () =>
  import(/* webpackChunkName: "Whatsapp-Test-Connector" */ '@/views/whatsapp/onboarding/TestConnector');

// GBM ROUTES
const GBMLandingPage = () => import(/* webpackChunkName: "GBM-LandingPage" */ '@/views/gbm/LandingPage');
const GBMOnboardingPage = () => import(/* webpackChunkName: "GBM-Onboarding" */ '@/views/gbm/onboarding/Index');
const TermsPage = () => import(/* webpackChunkName: "GBM-Terms" */ '@/views/gbm/onboarding/Terms');
const LoginPage = () => import(/* webpackChunkName: "GBM-Login" */ '@/views/gbm/onboarding/Login');
const SelectBrand = () => import(/* webpackChunkName: "GBM-SelectBrand" */ '@/views/gbm/onboarding/SelectBrand');
const ConversationalSettings = () =>
  import(/* webpackChunkName: "GBM-ConversationalSettings" */ '@/views/gbm/onboarding/ConversationalSettings');
const AgentInteractions = () =>
  import(/* webpackChunkName: "GBM-AgentInteractions" */ '@/views/gbm/onboarding/AgentInteractions');
const NonLocalEntryPoint = () =>
  import(/* webpackChunkName: "GBM-NonLocalEntryPoint" */ '@/views/gbm/onboarding/NonLocalEntryPoint');
const UrlEntryPoint = () => import(/* webpackChunkName: "GBM-UrlEntryPoint" */ '@/views/gbm/onboarding/UrlEntryPoint');
const LocationEntryPoints = () =>
  import(/* webpackChunkName: "GBM-LocationEntryPoints" */ '@/views/gbm/onboarding/LocationEntryPoints');
const SkillRouting = () => import(/* webpackChunkName: "GBM-SkillRouting" */ '@/views/gbm/onboarding/SkillRouting');
const Settings = () => import(/* webpackChunkName: "GBM-Settings" */ '@/views/gbm/onboarding/Settings');
const TestLinks = () => import(/* webpackChunkName: "GBM-TestLinks" */ '@/views/gbm/onboarding/TestLinks');
const VerifyConnector = () =>
  import(/* webpackChunkName: "GBM-VerifyConnector" */ '@/views/gbm/onboarding/VerifyConnector');
const LaunchConnector = () =>
  import(/* webpackChunkName: "GBM-LaunchConnector" */ '@/views/gbm/onboarding/LaunchConnector');

const routes = [
  {
    path: `/${appCode}`,
    name: `${appCode}`,
    redirect: `/${appCode}/channel-setup`,
  },
  {
    path: `/${appCode}/channel-setup`,
    name: `${appCode}:ChannelSetup`,
    components: { [appCode]: ChannelSetup },
  },
  {
    path: `/${appCode}/gbm`,
    name: 'GBM/Landing-Page',
    components: { [appCode]: GBMLandingPage },
  },
  {
    path: `/${appCode}/gbm/onboard`,
    name: 'GBM-Onboard',
    components: { [appCode]: GBMOnboardingPage },
    children: [
      {
        path: 'terms',
        name: 'GBM/Terms-Page',
        component: TermsPage,
      },
      {
        path: 'google-login',
        name: 'GBM/Login-Page',
        component: LoginPage,
      },
      {
        path: 'connectors/:connectorId/businesses',
        name: 'GBM/Google-SelectBrand',
        component: SelectBrand,
      },

      {
        path: 'connectors/:connectorId/conversational-settings',
        name: 'GBM/Conversational-Settings',
        component: ConversationalSettings,
      },
      {
        path: 'connectors/:connectorId/agent-availability',
        name: 'GBM/Agent-Interactions',
        component: AgentInteractions,
      },
      {
        path: 'connectors/:connectorId/non-local-entry-points',
        name: 'GBM/Non-Local-Entry-Points',
        component: NonLocalEntryPoint,
      },
      {
        path: 'connectors/:connectorId/url-entry-points',
        name: 'GBM/URL-Entry-Points',
        component: UrlEntryPoint,
      },
      {
        path: 'connectors/:connectorId/location-entry-points',
        name: 'GBM/Location-Entry-Points',
        component: LocationEntryPoints,
      },
      {
        path: 'connectors/:connectorId/skills',
        name: 'GBM/Skill-Routing',
        component: SkillRouting,
      },
      {
        path: 'connectors/:connectorId/settings',
        name: 'GBM/Settings',
        component: Settings,
      },
      {
        path: 'connectors/:connectorId/test-links',
        name: 'GBM/Test-Links',
        component: TestLinks,
      },
      {
        path: 'connectors/:connectorId/verify',
        name: 'GBM/Verify-Connector',
        component: VerifyConnector,
      },
      {
        path: 'connectors/:connectorId/launch',
        name: 'GBM/Launch-Connector',
        component: LaunchConnector,
      },
    ],
  },
  {
    path: `/${appCode}/whatsapp`,
    name: 'WhatsApp/Home-Page',
    components: { [appCode]: WhatsAppHomePage },
  },
  {
    path: `/${appCode}/whatsapp/onboard`,
    name: 'WhatApp-Onboard',
    components: { [appCode]: WhatsAppOnboardingPage },
    children: [
      {
        path: 'embedded-signup',
        name: 'WhatsApp/Embedded-SignUp',
        component: WhatsAppLoginPage,
      },
      {
        path: ':connectorId?/select-locale',
        name: 'WhatsApp/Select-Locale',
        component: WhatsAppSelectLocale,
      },
      {
        path: ':connectorId/edit-profile',
        name: 'WhatsApp/Edit-Profile',
        component: WhatsAppEditProfile,
      },
      {
        path: ':connectorId/configure-connector',
        name: 'WhatsApp/Configure-Connector',
        component: WhatsAppConfigureConnector,
      },
      {
        path: ':connectorId/configure-commerce',
        name: 'WhatsApp/Configure-Commerce',
        component: WhatsAppConfigureCommerce,
      },
      {
        path: ':connectorId/skill-routing',
        name: 'WhatsApp/Skill-Routing',
        component: WhatsAppSkillRouting,
      },
      {
        path: ':connectorId/test-connector',
        name: 'WhatsApp/Test-Connector',
        component: WhatsAppTestConnector,
      },
    ],
  },
  {
    path: `/${appCode}/amb`,
    name: 'AMB/Landing-Page',
    components: { [appCode]: AMBLandingPage },
  },
  {
    path: `/${appCode}/amb/onboard`,
    name: 'AMB-Onboard',
    components: { [appCode]: AMBOnboardingPage },
    children: [
      {
        path: 'apple-business',
        name: 'AMB/Apple-Business',
        component: AppleBusinessPage,
      },
      {
        path: ':connectorId?/connector-info',
        name: 'AMB/Connector-Info',
        component: ConnectorInfoPage,
      },
      {
        path: ':connectorId/configure-connector',
        name: 'AMB/Configure-Connector',
        component: ConfigureConnectorPage,
      },
      {
        path: ':connectorId/skills',
        name: 'AMB/Skill-Routing',
        component: SkillRoutingPage,
      },
      {
        path: ':connectorId/test-connector',
        name: 'AMB/Test-Connector',
        component: TestConnectorPage,
      },
      {
        path: ':connectorId/entry-points',
        name: 'AMB/Entry-Points',
        component: EntryPointsPage,
      },
    ],
  },
  {
    path: `/${appCode}/sms`,
    name: 'SMS/Landing-Page',
    components: { [appCode]: SMSLandingPage },
  },
  {
    path: `/${appCode}/sms/onboard`,
    name: 'SMS-Onboard',
    components: { [appCode]: SMSOnboardingPage },
    children: [
      {
        path: ':connectorId?/choose-provider',
        name: 'SMS/Create-Connector',
        component: SMSCreateConnector,
      },
      {
        path: ':connectorId?/configure-connector/:data?',
        name: 'SMS/Configure-Connector',
        component: SMSConfigureConnector,
      },
      {
        path: ':connectorId?/select-number',
        name: 'SMS/Select-Number',
        component: SMSSelectNumber,
      },
      {
        path: ':connectorId?/skill-routing',
        name: 'SMS/Skill-Routing',
        component: SMSSkillRouting,
      },
      {
        path: ':connectorId/test-connector',
        name: 'SMS/Test-Connector',
        component: SMSTestConnector,
      },
    ],
  },
];

export default routes;
